import * as React from 'react'

import styles from '@mui/material/AccordionSummary/accordionSummaryClasses'
import MuiAccordionSummary, {
  type AccordionSummaryProps,
} from '@mui/material/AccordionSummary'

import ExpandMore from '@mui/icons-material/ExpandMore'
import styled from '@mui/material/styles/styled'

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary expandIcon={<ExpandMore />} {...props} />
))(() => ({
  padding: 0,
  minHeight: 'unset',
  [`& .${styles.content}`]: {
    margin: 0,
  },
}))
